import React, { useState } from 'react'
import Carousel from '../MiniCarousel/Carousel'
import {
  LOCATION_OVERVIEW_MENU_OPTIONS,
  CONDITIONS_OVERVIEW_MENU_OPTIONS,
  CLIENTELE_OVERVIEW_MENU_OPTIONS,
  INSURANCE_OVERVIEW_MENU_OPTIONS,
  RESOURCES_OVERVIEW_MENU_OPTIONS
} from '../../utils/search/defaultAutocompleteLocationList'
import ChipList from '../ChipList'
import OverviewTitle from './OverviewMenuTitle'
import InsuranceCarouselItem from './InsuranceCarouselItem'
import CarouselItem from './CarouselItem'
import { isMobile } from 'react-device-detect'
import { generateBrowsePageUrlWithSearchState } from '../../utils/search/generateBrowsePageUrlWithSearchState'
import FilterPillList from '../organisms/FilterPillList/FilterPillList'
import { createBrowseUrlFromSearchStateExcludingGeo } from '../../utils/search/createBrowseUrlFromSearchStateExcludingGeo'
import {
  isFacetPageType,
  isLocationPageType
} from '../../domain/useCases/pageTypeCheck'

const CAROUSEL_DEFAULT_PROPS = {
  hideNavigation: true,
  smallArrows: true,
  className: `-ml-8 -mr-8 pb-6`
}
const topArrowPosition = '5' //tailwind size value

const CAROUSEL_LOCATIONS_PROPS = {
  ...CAROUSEL_DEFAULT_PROPS,
  id: 'overview-menu-locations',
  itemsCount: LOCATION_OVERVIEW_MENU_OPTIONS.length,

  topArrowPosition
}

const CAROUSEL_INSURANCE_PROPS = {
  ...CAROUSEL_DEFAULT_PROPS,
  id: 'overview-menu-insurance',
  itemsCount: INSURANCE_OVERVIEW_MENU_OPTIONS.length
}

const CAROUSEL_RESOURCES_PROPS = {
  ...CAROUSEL_DEFAULT_PROPS,
  id: 'overview-menu-resources',
  itemsCount: RESOURCES_OVERVIEW_MENU_OPTIONS.length,
  className: `-ml-8 -mr-8`,
  topArrowPosition
}

const CLIENTELE_LIST_MOBILE_MAX_ITEMS = 5
const CONDITIONS_LIST_MOBILE_MAX_ITEMS = 4

const getChipsLimitedListByDevice = (list, maxItems) => {
  return isMobile ? list.slice(0, maxItems) : list
}

const getChipsListLimitedByDeviceWithMore = (list, maxItems, title, link) => {
  return getChipsLimitedListByDevice(list, maxItems).concat({
    title,
    link
  })
}

const OverviewMenu = ({ pageType }) => {
  const [showFilterPillTitle, setShowFilterPillTitle] = useState(false)

  const referral = 'searchboxHero-overviewMenu'
  const addReferralToUrl = (url) => `/${url}&referral=${referral}`

  const addLocationsLink = (item) => ({
    ...item,
    link: addReferralToUrl(
      createBrowseUrlFromSearchStateExcludingGeo({
        simpleLocationName: item.title
      })
    )
  })

  const addConditionLink = (item) => {
    if (item.title.toLowerCase() === 'detox') {
      return addTreatmentSerivcesLink(item)
    }

    return {
      ...item,
      link: addReferralToUrl(
        generateBrowsePageUrlWithSearchState({
          term: 'what_we_treat',
          value: item.term
        })
      )
    }
  }

  const addTreatmentSerivcesLink = (item) => ({
    ...item,
    link: addReferralToUrl(
      generateBrowsePageUrlWithSearchState({
        term: 'treatment_services',
        value: item.title
      })
    )
  })

  const addClienteleLink = (item) => ({
    ...item,
    link: addReferralToUrl(
      generateBrowsePageUrlWithSearchState({
        term: 'who_we_treat',
        value: item.term
      })
    )
  })

  const addInsuranceLink = (item) => ({
    ...item,
    link: addReferralToUrl(
      generateBrowsePageUrlWithSearchState({
        term: 'accepted_insurance',
        value: item.title
      })
    )
  })

  const addResourcesLink = (item) => ({
    ...item,
    link: addReferralToUrl(
      generateBrowsePageUrlWithSearchState({
        term: 'resource_type',
        value: item.title
      })
    )
  })

  return (
    <div
      className={`overview-menu h-full overflow-x-hidden overflow-y-scroll bg-white px-6 pb-28 pt-6 md:px-8 md:pb-6`}
    >
      {showFilterPillTitle && <OverviewTitle>Selected Filters</OverviewTitle>}
      <FilterPillList
        fromFacetOrLocationPage={
          isFacetPageType(pageType) || isLocationPageType(pageType)
        }
        onHasFilter={(hasfilters) => {
          setShowFilterPillTitle(hasfilters)
        }}
        className="pb-4"
      />

      <OverviewTitle>Top Locations</OverviewTitle>
      <Carousel {...CAROUSEL_LOCATIONS_PROPS}>
        {LOCATION_OVERVIEW_MENU_OPTIONS.map(addLocationsLink).map(
          (location) => (
            <CarouselItem
              key={location.slug}
              item={location}
              link={location.link}
            />
          )
        )}
      </Carousel>
      <OverviewTitle>Common Conditions</OverviewTitle>
      <ChipList
        className="pb-[18px]"
        items={getChipsListLimitedByDeviceWithMore(
          CONDITIONS_OVERVIEW_MENU_OPTIONS.map(addConditionLink),
          CONDITIONS_LIST_MOBILE_MAX_ITEMS,
          '30+',
          '/condition/'
        )}
      />
      <OverviewTitle>Centers by Accepted Insurance</OverviewTitle>
      <Carousel {...CAROUSEL_INSURANCE_PROPS}>
        {INSURANCE_OVERVIEW_MENU_OPTIONS.map(addInsuranceLink).map(
          (insurance) => (
            <InsuranceCarouselItem
              key={insurance.slug}
              insuranceItem={insurance}
              link={insurance.link}
            />
          )
        )}
      </Carousel>
      <OverviewTitle>Clientele Specialties</OverviewTitle>
      <ChipList
        className="pb-[18px]"
        items={getChipsLimitedListByDevice(
          CLIENTELE_OVERVIEW_MENU_OPTIONS.map(addClienteleLink),
          CLIENTELE_LIST_MOBILE_MAX_ITEMS
        )}
      />
      <OverviewTitle>Resources</OverviewTitle>
      <Carousel {...CAROUSEL_RESOURCES_PROPS}>
        {RESOURCES_OVERVIEW_MENU_OPTIONS.map(addResourcesLink).map(
          (resource) => (
            <CarouselItem
              key={resource.slug}
              item={resource}
              link={`https://recovery.com/${resource.slug}/?referral=searchboxhero-overviewmenu/`}
            />
          )
        )}
      </Carousel>
    </div>
  )
}

export default OverviewMenu
